import React, { useState } from 'react';
import { Mic, Square, SendHorizonal, Loader2 } from 'lucide-react';
import { useMicRecorder } from '../voice/useMicRecorder';
import { transcribeBlob } from '../voice/transcribe';

export const DrDanInput = ({ onSend, disabled }) => {
  const [text, setText] = useState('');
  const [transcribing, setTranscribing] = useState(false);
  const [micMsg, setMicMsg] = useState('');
  const mic = useMicRecorder({
    autoStop: true,
    onBlob: async (blob) => {
      setTranscribing(true);
      try {
        const said = (await transcribeBlob(blob, 'drdan')).trim();
        if (said) setText((t) => (t ? `${t} ${said}` : said));
        else setMicMsg("I couldn't hear that. Try again.");
      } catch {
        setMicMsg("Couldn't transcribe that. Please type instead.");
      } finally {
        setTranscribing(false);
      }
    },
  });

  const send = () => {
    if (!text.trim() || disabled) return;
    onSend(text.trim());
    setText('');
  };
  const toggleMic = () => { setMicMsg(''); mic.clearError(); return mic.recording ? mic.stop() : mic.start(); };
  const note = mic.error || micMsg || (mic.recording ? (mic.silent ? 'No sound yet. Check your microphone.' : 'Listening… tap stop when done') : '') || (transcribing ? 'Transcribing…' : '');

  return (
    <div className="border-t bg-white p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
      {note && <p className={`text-xs mb-2 ${mic.error ? 'text-rose-600' : 'text-slate-500'}`} data-testid="dr-dan-mic-status">{note}</p>}
      <div className="flex items-end gap-2">
        <button type="button" onClick={toggleMic} disabled={transcribing} data-testid="dr-dan-mic-btn" title={mic.recording ? 'Stop' : 'Speak your question'}
          className={`relative h-11 w-11 shrink-0 rounded-full flex items-center justify-center transition-colors ${mic.recording ? 'bg-rose-600 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`}>
          {transcribing ? <Loader2 className="w-5 h-5 animate-spin" /> : mic.recording ? <Square className="w-4 h-4" /> : <Mic className="w-5 h-5" />}
          {mic.recording && <span className="absolute inset-0 rounded-full ring-4 ring-rose-300" style={{ opacity: 0.3 + mic.level * 0.7 }} />}
        </button>
        <textarea value={text} onChange={(e) => setText(e.target.value)} rows={1} data-testid="dr-dan-input"
          onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); } }}
          placeholder="Ask Dr. G anything…"
          className="flex-1 resize-none max-h-32 min-h-[44px] rounded-2xl border border-slate-200 px-4 py-2.5 text-base sm:text-sm min-w-0 focus:outline-none focus:ring-2 focus:ring-sky-200 focus:border-sky-400" />
        <button type="button" onClick={send} disabled={disabled || !text.trim()} data-testid="dr-dan-send-btn"
          className="h-11 w-11 shrink-0 rounded-full bg-sky-600 hover:bg-sky-700 disabled:bg-slate-200 text-white flex items-center justify-center transition-colors">
          <SendHorizonal className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};
